module.exports = __webpack_public_path__ + "static/media/9.d37ed4fb.jpg";